import { getPriceVisibility } from 'src/app/dataAnalytics/utils/getPriceVisibility';
import type { Tealium } from 'src/types/appState';

import { EVENT_NAME_VIEW_REFRESH_ERROR } from '../constants';

export const eventName = EVENT_NAME_VIEW_REFRESH_ERROR;

export default (tealium: Tealium) => {
  const {
    cajaFlowType,
    experiments,
    draftId,
    productSetId,
    priceVisibility,
    productPricing,
    jobAdTypeSelected,
  } = tealium;
  return {
    cajaFlowType,
    experiments,
    adDraftId: draftId,
    adProductSetId: productSetId,
    isPriceHidden: getPriceVisibility(priceVisibility),
    adProductPricing: productPricing,
    adProductName: [jobAdTypeSelected],
  };
};
